import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { ReactComponent as Plus } from "../../assets/images/icons/Plues.svg";
import { ReactComponent as Drag } from "../../assets/images/icons/DragIcon.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/crossIconAdvancedFilter.svg";
import { ReactComponent as True } from "../../assets/images/icons/True.svg";
import { ReactComponent as NewDelete } from "../../assets/images/NewDelete.svg";
import { ReactComponent as View } from "../../assets/images/icons/ViewEye.svg";
import { ReactComponent as Task2 } from "../../assets/images/icons/Task2.svg";
import { ReactComponent as ActivityIcon } from "../../assets/images/ActivityIcon.svg";
import { ReactComponent as LinkSvg } from "../../assets/images/icons/LinkSvg.svg";
import { ReactComponent as ReloadIcon } from "../../assets/images/icons/ReloadIcon.svg";
import { ReactComponent as Lock } from "../../assets/images/icons/Lock.svg";
import { ReactComponent as GeneralInfo } from "../../assets/images/icons/GeneralInfo.svg";
import { ReactComponent as VendorAddress } from "../../assets/images/icons/Address.svg";
import { ReactComponent as VendorContact } from "../../assets/images/icons/VendorContact.svg";
import { ReactComponent as FinanicalDetails } from "../../assets/images/icons/FinancialDetails.svg";
import { ReactComponent as Attachments } from "../../assets/images/icons/Attachments.svg";
import { ReactComponent as Notes } from "../../assets/images/icons/Notes.svg";
import { ReactComponent as Sub } from "../../assets/images/icons/Sub.svg";
import { ReactComponent as AddTemplateCircle } from "../../assets/images/icons/AddTemplateCircle.svg";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import { Dialog, FormControlLabel, Switch } from "@mui/material";
import InputComponent from "../UniversalComponents/InputComponent";
import Button from "./../UniversalComponents/DefaultButton";
import Activity from "../../assets/images/Activity.png";
import Attachment from "../../assets/images/Attachment.png";
import Recurrence from "../../assets/images/Recurrence.png";
import LinkToTask from "../../assets/images/LinkToTaskPod.png";
import Subtask from "../../assets/images/Subtask.png";
import DefaultIframeImage from "../../assets/images/DefaultIframeImage.png";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import { ReactComponent as ActiveLink } from "../../assets/images/icons/ActiveLink.svg";
import { ReactComponent as ActiveActivity } from "../../assets/images/icons/ActiveActivity.svg";
import { ReactComponent as ActiveAttachment } from "../../assets/images/icons/ActiveAttachment.svg";
import BasicSelect from "../Task/BasicSelect";
import styled from "@emotion/styled";
import { date, object } from "yup";

import useClickOutside from "../../hooks/Screen/useClickOutside";
import FloatingElement from "../UniversalComponents/FloatingElement";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { NODE_URL } from "../../utils/constants";
import { usePostApiMutation } from "../../utils/customer/customerTaskTable";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import {
  useDeleteLinkedSectionMutation,
  useDeleteTemplateMutation,
  useFetchAllTemplateQuery,
  useLazyFetchAllSectionsQuery,
  useLazyFetchLinkedSectionsFieldsQuery,
  useLazyFetchLinkedSectionsQuery,
} from "../../utils/customer/customerSelect";

const AddTemplate = ({ sectionlist, setSectionlist, RefetchAllSections }) => {
  const [filterSectionName, setFilterSectionName] = useState("");
  const [viewName, setViewName] = useState("");
  const [addTemplate, setAddTemplate] = useState(false);
  const [openAddUpdateTemplate, setOpenAddUpdateTemplate] = useState(false);
  const [addTemplateValues, setAddtemplateValues] = useState({ TemplateName: "", color: "", description: "" });
  const [getAllTemplate, setGetAllTemplate] = useState(null);
  const [linkedSections, setLinkedSections] = useState(null);
  const [field, setField] = useState({});

  const [selectedColor, setSelectedColor] = useState("#5F5E52");
  const [handleColorBox, setHandleColorBox] = useState(false);
  const [imageRender, setImageRender] = useState([]);
  const [selectedSectionLabel, setselectedSectionLabel] = useState();
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [viewAllTemplate, setViewAllTemplate] = useState(false);
  const [draggedSectionData, setDraggedSectionData] = useState(null);
  const [renderIframeImage, setRenderIframeImage] = useState(null);
  const [dragItemIndex, setDragItemIndex] = useState(null);
  const [selectedTemplate, SetSelectedTemplate] = useState(null);
  const [showList, setShowList] = useState(null);
  const [isSize, setIsSize] = useState();
  const dropdownRef = useRef(null);
  const sectionRefs = useRef({});
  const dispatch = useDispatch();

  // 1. Create/Update template
  const [
    AddUpdateTemplate,
    {
      data: templateAddUpdate,
      isLoading: isTemplateAddUpdateLoading,
      isError: isTemplateAddUpdateError,
      isSuccess: isTemplateAddUpdateSuccess,
      error: TemplateError,
    },
  ] = usePostApiMutation();

  // 2. Fetch all created templates
  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery();

  // 3. Section linking
  const [
    SectionLinking,
    {
      data: SelectionLink,
      isLoading: isSelectionLinkLoading,
      isError: isSelectionLinkError,
      isSuccess: isSelectionLinkSuccess,
      error: SelecrtionLinkError,
    },
  ] = usePostApiMutation();

  // 4. Fetch all linked sections with template
  const [
    FetchAllLinkedSections,
    {
      data: GetAllLinkedSections,
      isLoading: isGetAllLinkedSectionsLoading,
      isError: isGetAllLinkedSectionsError,
      isSuccess: isGetAllLinkedSectionsSuccess,
      error: GetAllLinkedSectionsError,
    },
  ] = useLazyFetchLinkedSectionsQuery();

  //5. delete linked section
  const [
    DeleteLinking,
    {
      data: deletedLinkedSection,
      isLoading: isDeletedLinkedSectionLoading,
      isError: isDeletedLinkedSectionError,
      isSuccess: isDeletedLinkedSectionSuccess,
      error: deletedLinkedSectionError,
    },
  ] = useDeleteLinkedSectionMutation();

  // 6. fetch linked section fields
  const [
    GetLinkedSectionFields,
    {
      data: fetchLinkedSectionFields,
      isLoading: isFetchLinkedSectionFieldsLoading,
      isError: isFetchLinkedSectionFieldsError,
      isSuccess: isFetchLinkedSectionFieldsSuccess,
      error: FetchLinkedSectionFieldsError,
    },
  ] = useLazyFetchLinkedSectionsFieldsQuery();

  // Delete Template
  const [
    DeleteTemplate,
    {
      data: DeleteTemplateData,
      isLoading: isDeleteTemplateLoading,
      isError: isDeleteTemplatedError,
      isSuccess: isDeleteTemplatedSuccess,
      error: DeleteTemplatedError,
    },
  ] = useDeleteTemplateMutation();

  // HANDLE ADD/UPDATE TEMPLATE
  useEffect(() => {
    if (isTemplateAddUpdateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isTemplateAddUpdateSuccess && templateAddUpdate?.success) {
      dispatch(pushAlert({ message: templateAddUpdate.message, type: "success", visible: true }));

      setAddTemplate((prev) => !prev);
      setAddtemplateValues({ TemplateName: "", color: "", description: "" });

      refetchGetAllTemplate();
    } else if (isTemplateAddUpdateError) {
      dispatch(
        pushAlert({
          message: TemplateError?.data?.message || "Error adding section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isTemplateAddUpdateLoading, isTemplateAddUpdateSuccess, isTemplateAddUpdateError]);

  // HANDLE GET ALL TEMPLATES
  useEffect(() => {
    if (isGetAllTemplatesLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isGetAllTemplatesSuccess && GetAlltemplates?.success) {
      dispatch(pushAlert({ message: GetAlltemplates.message, type: "success", visible: true }));

      const allTemplates = GetAlltemplates?.data || [];
      setGetAllTemplate(allTemplates);

      if (allTemplates.length > 0) {
        const matchedTemplate = addTemplateValues?.TemplateId
          ? allTemplates.find((temp) => temp?.id === addTemplateValues.TemplateId)
          : null;

        SetSelectedTemplate(matchedTemplate || allTemplates[allTemplates.length - 1]);
      } else {
        SetSelectedTemplate(null);
      }
    } else if (isGetAllTemplatesError) {
      dispatch(
        pushAlert({
          message: GetAllTemplatesError?.data?.message || "Error fetching templates",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isGetAllTemplatesLoading,
    isGetAllTemplatesSuccess,
    isGetAllTemplatesError,
    GetAlltemplates,
    addTemplateValues?.TemplateId,
  ]);

  // get which section be linked with template
  useEffect(() => {
    if (isGetAllLinkedSectionsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isGetAllLinkedSectionsSuccess && GetAllLinkedSections?.success) {
      setLinkedSections(GetAllLinkedSections?.data || []);
      GetLinkedSectionFields({ TemplateId: selectedTemplate?.id, IsForm: true });
    } else if (isGetAllLinkedSectionsError) {
      dispatch(
        pushAlert({
          message: GetAllLinkedSectionsError?.data?.message || "Error fetching linked sections",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isGetAllLinkedSectionsLoading, isGetAllLinkedSectionsSuccess, isGetAllLinkedSectionsError, GetAllLinkedSections]);

  // HANDLE LINKING SECTION with Template
  useEffect(() => {
    if (isSelectionLinkLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isSelectionLinkSuccess && SelectionLink?.success) {
      dispatch(pushAlert({ message: SelectionLink?.message, type: "success", visible: true }));
      FetchAllLinkedSections({ TemplateId: selectedTemplate?.id });
      GetLinkedSectionFields({ TemplateId: selectedTemplate?.id, IsForm: true });
    } else if (isSelectionLinkError) {
      dispatch(
        pushAlert({
          message: SelecrtionLinkError?.data?.message || "Error linking section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isSelectionLinkLoading, isSelectionLinkSuccess, isSelectionLinkError]);

  // HANDLE delete LINKING SECTION with Template
  useEffect(() => {
    if (isDeletedLinkedSectionLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeletedLinkedSectionSuccess && deletedLinkedSection?.success) {
      dispatch(pushAlert({ message: deletedLinkedSection?.message, type: "success", visible: true }));
      FetchAllLinkedSections({ TemplateId: selectedTemplate.id }); // Refresh linked sections
      GetLinkedSectionFields({ TemplateId: selectedTemplate?.id, IsForm: true });
    } else if (isDeletedLinkedSectionError) {
      dispatch(
        pushAlert({
          message: deletedLinkedSectionError?.data?.message || "Error unlinking section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isDeletedLinkedSectionLoading, isDeletedLinkedSectionSuccess, isDeletedLinkedSectionError]);

  //get Linked Section fields
  useEffect(() => {
    if (isFetchLinkedSectionFieldsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFetchLinkedSectionFieldsSuccess && fetchLinkedSectionFields?.status) {
      dispatch(
        pushAlert({
          message: fetchLinkedSectionFields?.message || "Section fields fetched successfully",
          type: "success",
          visible: true,
        })
      );
      if (fetchLinkedSectionFields?.data) {
        setField(fetchLinkedSectionFields?.data);
      }
    }

    if (isFetchLinkedSectionFieldsError) {
      dispatch(
        pushAlert({
          message: FetchLinkedSectionFieldsError?.data?.message || "Failed to fetch section fields",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isFetchLinkedSectionFieldsLoading,
    isFetchLinkedSectionFieldsSuccess,
    isFetchLinkedSectionFieldsError,
    fetchLinkedSectionFields?.data,
    viewAllTemplate,
  ]);

  // CLOSE WHEN CLICKING OUTSIDE
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSize(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // SCROLL CONTENT DEPENDING ON SELECTED TAB
  useEffect(() => {
    if (selectedSectionLabel && sectionRefs.current[selectedSectionLabel]) {
      sectionRefs.current[selectedSectionLabel].scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedSectionLabel]);

  useEffect(() => {
    if (selectedTemplate?.id) {
      FetchAllLinkedSections({ TemplateId: selectedTemplate.id });
    }
  }, [selectedTemplate?.id]);

  // 🔁 HANDLE DELETE TEMPLATE
  useEffect(() => {
    if (isDeleteTemplateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isDeleteTemplatedSuccess && DeleteTemplateData?.status) {
      dispatch(
        pushAlert({
          message: DeleteTemplateData.message || "Template deleted successfully",
          type: "success",
          visible: true,
        })
      );
      setIsConfirmDelete(false); // close confirmation dialog
    } else if (isDeleteTemplatedError) {
      dispatch(
        pushAlert({
          message: DeleteTemplatedError?.data?.message || "Error deleting template",
          type: "danger",
          visible: true,
        })
      );
    }
    setIsConfirmDelete(false);
  }, [
    isDeleteTemplateLoading,
    isDeleteTemplatedSuccess,
    isDeleteTemplatedError,
    DeleteTemplateData,
    DeleteTemplatedError,
  ]);

  const handleFieldChange = (fieldKey, newValue) => {};
  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 42,
      height: 22,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#65C466",
            opacity: 1,
            border: 0,
            ...theme.applyStyles("dark", {
              backgroundColor: "#2ECA45",
            }),
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "#33cf4d",
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color: theme.palette.grey[100],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[600],
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.7,
          ...theme.applyStyles("dark", {
            opacity: 0.3,
          }),
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        ...theme.applyStyles("dark", {
          backgroundColor: "#39393D",
        }),
      },
    })
  );

  //render field by type
  const renderFieldByType = (fieldValue, sectionLabel, handleFieldChange) => {
    switch (fieldValue?.type) {
      case "text":
      case "string":
        return <InputComponent type="text" placeholder={fieldValue?.label} value={""} isDisabled />;

      case "int":
      case "integer":
      case "number":
      case "float":
        return <InputComponent type="number" value={""} placeholder={fieldValue?.label} isDisabled />;

      case "boolean":
      case "checkbox":
        return (
          // <input
          //
          //   type="checkbox"
          //   checked={ ?? field.value}
          //   onChange={(e) => handleFieldChange( field.key, e.target.checked)}
          //   className="h-5 w-5"
          // />
          <FormControlLabel
            control={
              <IOSSwitch checked={true} onChange={(e) => handleFieldChange(fieldValue?.key, e.target.checked)} />
            }
            disabled
          />
        );

      case "date":
        return (
          <div
            className={`grid ${fieldValue?.key == "Due Date" && sectionLabel === "Task Info" ? "grid-cols-2" : "grid-cols-1"}  w-full`}
          >
            <DatePickerComponent
              value={""}
              onChange={(date) => handleFieldChange(fieldValue?.key, date)}
              className="w-full rounded-md bg-gray-100 border-b-[1px]"
              innerClassName="h-[35px]"
              placeholder="Select date"
              size="small"
              isDisabled
            />
            {field?.["Recurrence"] && sectionLabel === "Task Info" && fieldValue?.key == "Due Date" && (
              <div className="w-full flex items-start justify-end gap-x-2">
                <ReloadIcon /> <span className=" text-sm text-[#2999BC]">Recurrence</span>
              </div>
            )}
          </div>
        );

      case "Dropdown":
      case "dropdown":
      case "select":
        return (
          <div className="w-full  border-b-[1px] rounded-lg">
            <BasicSelect
              isMulti
              size="large"
              onChange={(e) => handleFieldChange(e.target.value)}
              className="w-full px-3 py-2 border rounded-md bg-gray-100 border-b-[1px]"
              disabled
            />
          </div>
        );
      case "Mutli_select":
      case "Person":
        return (
          <div className="w-full  border-b-[1px] rounded-lg">
            <BasicSelect
              isMulti
              size="large"
              onChange={(e) => handleFieldChange(e.target.value)}
              className="w-full px-3 py-2 border rounded-md bg-gray-100 border-b-[1px]"
              disabled
            />
          </div>
        );
      case "Subtask":
        return (
          <div className="flex flex-col items-centre justify-start border-2 w-full py-3 rounded-md">
            <div className="ml-3 gap-3">
              <span>+</span>
              <span className="text-[#1D4469]">Add Subtask</span>
            </div>
          </div>
        );
      default:
        return (
          <InputComponent
            type="text"
            placeholder={fieldValue?.label}
            onChange={(e) => handleFieldChange(fieldValue.key, e.target.value)}
            className=""
            isDisabled
          />
        );
    }
  };

  const handleColorClick = (color, choiceId) => {
    setSelectedColor(() => color);
  };

  const colors = [
    "#6B27D3",
    "#74A431",
    "#9A0D94",
    "#EE950F",
    "#00656B",
    "#D4372A",
    "#5F5E52",
    "#DB4A6B",
    "#164A79",
    "#E38BAB",
    "#310082",
    "#962729",
    "#0E8BFE",
    "#BE1176",
    "#73471B",
    "#7A518E",
    "#134E30",
    "#2F18DB",
    "#67243D",
    "#3D46F4",
    "#ED592E",
    "#879300",
    "#2792B8",
    "#BA612E",
    "#9B6F00",
    "#3F3F3F",
  ];

  const colorcloseoutsideclick = useClickOutside(() => setHandleColorBox((prev) => !prev));

  const CloseSectionPop = () => {
    setAddTemplate((prev) => !prev);
  };
  const templaetdata = [
    {
      color: "#984AEA",
      title: "Task",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
    {
      color: "#4B9CA5",
      title: "Deal",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
    {
      color: "#4C53D7",
      title: "Lead",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
    {
      color: "#DA873E",
      title: "Project",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
    {
      color: "#EA4A85",
      title: "Task 2",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
    {
      color: "#C54042",
      title: "Deal 2",
      CreatedBy: "Ketan Bhatt",
      CreatedTo: "Global FPO",
    },
  ];
  const MatchIcon = {
    Activity: (
      <div className="p-[9px] bg-[#F0F0F0] rounded-lg">
        <ActiveActivity />
      </div>
    ),
    LinkToTask: (
      <div className="p-[9px] bg-[#F0F0F0] rounded-lg">
        <ActiveLink />
      </div>
    ),
    Attachment: (
      <div className="p-[9px] bg-[#F0F0F0] rounded-lg">
        <ActiveAttachment />
      </div>
    ),
  };

  const IconSectionList = {
    Activity: <ActiveActivity />,
    LinkToTask: <ActiveLink />,
    Attachment: <ActiveAttachment />,
  };

  const IframeImage = {
    Activity: Activity,
    LinkToTask: LinkToTask,
    Attachment: Attachment,
    Recurrence: Recurrence,
    Subtask: Subtask,
  };

  // useEffect(() => {
  //   const currentKeys = Object.keys(field);

  //   const newKey = currentKeys[currentKeys.length - 1];

  //   if (newKey) {
  //     setImageRender(newKey);
  //   }
  // }, [field]);

  useEffect(() => {
    const data = Object.keys(IframeImage).includes(imageRender.toString());
    if (imageRender) {
      setRenderIframeImage(data);
    }
  }, [imageRender]);

  const handleDrop = () => {};

  const CloseTemplateNameField = useClickOutside(() => {
    setOpenAddUpdateTemplate((prev) => !prev);
  });

  //add and update the template (name)
  const handleAddAndUpdateTemplate = () => {
    const payload = {
      id: addTemplateValues?.TemplateId,
      template_name: addTemplateValues?.TemplateName,
    };
    AddUpdateTemplate({ data: payload, url: `${NODE_URL}template/create` });
  };

  const getDDMonthYYYYHM = (dateString) => {
    if (!dateString) {
      return;
    }

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  //checked section
  const handleCheckedSection = (section) => {
    if (!section || !selectedTemplate?.id) return;

    const payload = {
      template_id: selectedTemplate.id,
      section_id: section.id,
    };

    SectionLinking({ data: payload, url: `${NODE_URL}template/link-section` });
  };

  //delete linking with template
  const handleDeleteLinking = (section) => {
    if (!section || !selectedTemplate?.id) return;
    DeleteLinking({ TemplateId: selectedTemplate?.id, SectionId: section?.id });
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightText = (html, highlight) => {
    if (!highlight.trim()) return html;

    const regex = new RegExp(`(${highlight})`, "gi");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent;
      if (regex.test(text)) {
        const span = document.createElement("span");
        span.innerHTML = text.replace(regex, (match) => `<span class="bg-yellow-300">${match}</span>`);
        node.replaceWith(span);
      }
    }

    return tempDiv.innerHTML;
  };

  const handleTempleteList = (data, e) => {
    e.stopPropagation();
    SetSelectedTemplate(data);
    setViewAllTemplate((prev) => !prev);
    setLinkedSections(null);
    FetchAllLinkedSections({ TemplateId: data?.id });
  };

  const HandleShowList = (value) => {
    if (showList === value) {
      setShowList(null);
    } else {
      setShowList(value);
    }
  };

  const vendorInfo = [
    {
      id: 1,
      vendor_name: "General Info",
    },
    {
      id: 2,
      vendor_name: "Address",
    },
    {
      id: 3,
      vendor_name: "Contact",
    },
    {
      id: 4,
      vendor_name: "Financial Details",
    },
    {
      id: 5,
      vendor_name: "Attachments",
    },
    {
      id: 6,
      vendor_name: "Notes",
    },
  ];

  const vendorSVG = {
    1: <GeneralInfo />,
    2: <VendorAddress />,
    3: <VendorContact />,
    4: <FinanicalDetails />,
    5: <Attachments />,
    6: <Notes />,
  };

  const handleDeleteTemplate = () => {
    DeleteTemplate({ TemplateId: selectedTemplate?.id });
  };

  return (
    <>
      <div className="flex justify-center items-start p-2 min-h-0 grow overflow-y-auto gap-x-3">
        <div className="flex flex-col items-centre justify-between gap-2 border rounded-md p-2 overflow-y-auto border-[#BECBD3]  w-[18vw] h-[calc(100vh-121px)]">
          {/* <div
            className="flex p-[8px] items-center gap-[10px] rounded border border-[#D2DAE1] bg-[#F0F0F0] cursor-pointer"
            onClick={() => {
              setViewAllTemplate((prev) => !prev);
            }}
          >
            <View />
          </div> */}

          <div className="w-full flex flex-col min-h-0 grow gap-y-2">
            {/* Template List */}
            <div className="w-full flex items-center justify-between px-4 py-2 h-10 gap-y-3 rounded-md bg-[#CFCFCF33]">
              <span className="text-[#666] text-sm font-normal">TO DO HUB</span>
              <span
                className={`text-[#8E8E8E] ${showList === "ToDoHub" ? "bg-[#8e8e8e58]" : "bg-[#FFFFFF]"}  px-2 py-2 text-sm font-semibold rounded-md cursor-pointer`}
                onClick={() => HandleShowList("ToDoHub")}
              >
                <Sub />
              </span>
            </div>
            {showList === "ToDoHub" && (
              <div className="w-full flex flex-col px-2 py-1 overflow-y-auto thinscrollbar gap-y-3">
                {getAllTemplate?.map((data, index) => (
                  <div
                    key={index}
                    className={`w-full flex items-start sm:items-center justify-start sm:justify-between gap-3 flex-wrap sm:flex-nowrap py-2 px-4 cursor-pointer rounded-md ${selectedTemplate?.id === data?.id ? "bg-[#cccccc]" : ""} hover:bg-gray-100  transition`}
                    onClick={(e) => {
                      handleTempleteList(data, e);
                    }}
                  >
                    {/* Template Info */}
                    <div className="flex flex-col gap-y-1 sm:gap-y-2 text-left flex-1 min-w-0">
                      <div className="flex items-center gap-x-2 flex-wrap">
                        <Task2 />
                        <span className="text-[#666] text-sm font-medium truncate">{data?.template_name}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* vendor sections */}
            <div className="w-full flex items-center justify-between px-4 py-2 h-10 gap-y-3 rounded-md bg-[#CFCFCF33]">
              <span className="text-[#666] text-sm font-normal">Vendor</span>
              <span
                className={`text-[#8E8E8E] ${showList === "VENDOR" ? "bg-[#8e8e8e58]" : "bg-[#FFFFFF]"} rounded-md  px-2 py-2 text-sm font-semibold cursor-pointer`}
                onClick={() => HandleShowList("VENDOR")}
              >
                <Sub />
              </span>
            </div>
            {showList === "VENDOR" && (
              <div className="min-h-0 grow w-full flex flex-col px-2 py-1 overflow-y-auto thinscrollbar gap-y-3">
                {vendorInfo?.map((data, index) => (
                  <div
                    key={index}
                    className={`w-full flex items-start sm:items-center justify-start sm:justify-between gap-3 flex-wrap sm:flex-nowrap py-2 px-4 cursor-pointer rounded-md ${selectedTemplate?.id === data?.id ? "bg-[#cccccc]" : ""} hover:bg-gray-100  transition`}
                    onClick={(e) => {
                      // handleTempleteList(data, e);
                    }}
                  >
                    {/* vendor detail */}
                    <div className="flex flex-col gap-y-1 sm:gap-y-2 text-left flex-1 min-w-0">
                      <div className="flex items-center gap-x-2 flex-wrap">
                        {vendorSVG[data?.id]}
                        <span className="text-[#666] text-sm font-medium truncate">{data?.vendor_name}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* add the template */}
          <div
            className="flex items-center justify-center px-4 py-2 bg-[#1D4469] gap-2 rounded-lg"
            onClick={() => {
              setAddtemplateValues({ TemplateName: "", color: "", description: "" });
              setAddTemplate((prev) => !prev);
            }}
          >
            <AddTemplateCircle fill="#ffffff" />
            <button className="text-white text-base">Add New Template</button>
          </div>
        </div>

        <div className="flex items-start justify-center">
          {/* section list */}
          <div className="min-w-[25vw] w-[25vw] h-[calc(100vh-121px)] border rounded-tl-md border-[#BECBD3] flex flex-col">
            <h1 className="text-[#1D4469] font-[Poppins] text-lg font-medium lowercase leading-normal pt-4 px-4">
              Section List
            </h1>

            <div className="px-3 mt-3 gap-3 flex flex-col overflow-y-auto ">
              <MotionSearchBox
                expanded={true}
                isSearchActive={true}
                searchText={filterSectionName}
                setSearchText={setFilterSectionName}
                placeholder="Search..."
              />

              <div className="flex flex-col items-start justify-start w-full gap-y-3 pb-3 overflow-y-auto scrollbar-hidden">
                {sectionlist
                  ?.filter(
                    (list) =>
                      list?.section_name && list?.section_name?.toLowerCase().includes(filterSectionName?.toLowerCase())
                  )
                  .map((list, i) => {
                    const isLinked = linkedSections?.some((check) => check?.id === list?.id);

                    // Match section id with linked object

                    return (
                      <div
                        key={i}
                        onDragStart={() => setDraggedSectionData(list)}
                        draggable
                        onDragOver={(e) => {
                          setDragItemIndex(i);
                          e.preventDefault();
                        }}
                        onDrop={() => handleDrop(dragItemIndex)}
                        className={`flex items-center cursor-pointer group hover:bg-626262  justify-start px-3 py-2 border border-[#BECBD3] rounded-md w-full gap-x-3 ${
                          isLinked ? "bg-[#1D4469]" : ""
                        }`}
                      >
                        <Drag className="cursor-pointer" />

                        <input
                          type="checkbox"
                          onChange={() => {
                            isLinked ? handleDeleteLinking(list) : handleCheckedSection(list);
                          }}
                          checked={isLinked}
                          className="w-4 h-4 accent-[#e34d23] cursor-pointer border-[#BECBD3] rounded-sm"
                        />

                        <label
                          className={`font-[Poppins] text-base font-400 leading-normal flex items-center justify-center gap-x-2
                          ${isLinked ? "text-[#e6e6e6f4]" : "text-[#666] group-hover:text-white"}`}
                        >
                          {IconSectionList?.[list?.section_name]} {highlightText(list?.section_name, filterSectionName)}
                          {list?.is_locked === 1 && <Lock fill="#C9CDD7" />}
                        </label>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start justify-center min-h-0 grow">
            <div className="flex items-start justify-centre h-full">
              {/* Section with field*/}
              <div className="min-w-[25vw] w-[25vw] h-[calc(100vh-164px)] overflow-y-auto  border-y border-[#BECBD3] flex flex-col justify-start">
                <div className="py-3  px-4 flex items-center justify-between border-b border-[#BECBD3]">
                  <h4
                    className="w-full flex items-center justify-start text-[#1D4469] font-[Poppins] text-lg font-medium leading-normal cursor-pointer"
                    onClick={(e) => {
                      setAddTemplate((prev) => !prev);
                      setAddtemplateValues((prev) => ({
                        ...prev,
                        TemplateName: selectedTemplate?.template_name,
                        TemplateId: selectedTemplate?.id,
                      }));
                    }}
                  >
                    {selectedTemplate?.template_name}
                  </h4>

                  <div className="flex items-center justify-center gap-4 h-8">
                    {field &&
                      Object.entries(field)?.map(([item, data]) => {
                        return MatchIcon[data?.key];
                      })}
                    <NewDelete className="cursor-pointer p-[1px]" onClick={() => setIsConfirmDelete((prev) => !prev)} />
                  </div>
                </div>

                <div
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleCheckedSection(draggedSectionData)}
                  className={`${isSize ? "overflow-hidden" : "overflow-y-auto"}  scrollbar-hidden`}
                >
                  <form className="w-full gap-y-2 flex flex-col h-full">
                    <div className="flex flex-col items-center justify-start w-full gap-y-2 p-3">
                      <div className="w-full flex flex-col items-start justify-center gap-y-1">
                        <label className="w-full text-[#434852] font-poppins text-sm font-normal capitalize">
                          Customer
                        </label>
                        <BasicSelect
                          isMulti
                          size="large"
                          onChange={(e) => handleFieldChange(e.target.value)}
                          className="w-full px-3 py-2 border rounded-md bg-gray-100 border-b-[1px]"
                          disabled
                        />
                      </div>
                      <div className="w-full flex flex-col items-start justify-center gap-y-1">
                        <label className="w-full text-[#434852] font-poppins text-sm font-normal capitalize">
                          Category
                        </label>
                        <BasicSelect
                          isMulti
                          size="large"
                          onChange={(e) => handleFieldChange(e.target.value)}
                          className="w-full px-3 py-2 border rounded-md bg-gray-100 border-b-[1px]"
                          disabled
                        />
                      </div>
                    </div>

                    {/* render only the title */}
                    {false && (
                      <div
                        className={`w-full flex items-center justify-start flex-wrap ${
                          Object.keys(field).length > 0 ? "border-t border-b" : ""
                        } py-2 px-4`}
                      >
                        {field &&
                          Object.entries(field)?.map(([sectionLabel, sectionData]) => (
                            <span
                              onClick={() => setselectedSectionLabel(sectionLabel)}
                              className={`flex px-[15px] my-1 py-[10px] items-center gap-[5px] rounded-full border ${
                                sectionLabel === selectedSectionLabel
                                  ? "bg-[#1D4469] text-white"
                                  : "bg-[#dddddd8a] text-black"
                              } border-[#D2DAE1] border-opacity-50 cursor-pointer mr-2`}
                              key={sectionLabel}
                            >
                              {sectionData?.title}
                              {sectionData?.is_locked === 1 && (
                                <Lock
                                  fill={
                                    sectionLabel === selectedSectionLabel ||
                                    (!selectedSectionLabel &&
                                      sectionLabel === "Task Information" &&
                                      field?.["Task Information"] &&
                                      Object.keys(field).length)
                                      ? "#1D4469"
                                      : "#C9CDD7"
                                  }
                                />
                              )}
                            </span>
                          ))}
                      </div>
                    )}

                    {/* render all field */}
                    <div className="w-full min-h-0 grow overflow-y-auto scrollbar-hidden">
                      {field &&
                        Object.entries(field)?.map(([sectionLabel, sectionData]) => (
                          <div
                            key={sectionLabel}
                            ref={(el) => (sectionRefs.current[sectionLabel] = el)}
                            className="w-full px-3 py-1"
                          >
                            {/* Optional: Section Title */}
                            <div className="flex items-center justify-start gap-x-2 w-full">
                              <div className="text-base font-semibold text-[#1D4469] mb-2 whitespace-nowrap">
                                {sectionData?.title}
                              </div>
                              <div className="flex-1 h-1 bg-[#1d4469dc] rounded-lg mb-2"></div>
                            </div>

                            <div className="grid grid-cols-2 gap-2 w-full">
                              {sectionData?.fields?.map((data, index) => (
                                <div
                                  key={data?.value || index}
                                  className={`col-span-${data?.col_span || 2} flex flex-col items-start justify-start w-full my-1`}
                                >
                                  <label className="text-[#434852] font-poppins text-sm font-normal capitalize mb-1">
                                    {data?.label}
                                    {data?.is_required && <span className="text-red-500 ml-1">*</span>}
                                  </label>

                                  {/* Render the correct input type */}
                                  {renderFieldByType(data, sectionLabel, handleFieldChange)}
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </form>
                </div>
              </div>

              {/* iFrame */}
              <div className=" w-[25vw] h-[calc(100vh-164px)] bg-[#F3F5F7] flex items-centre overflow-auto scrollbar-hidden justify-centre rounded-tr-md border border-[#BECBD3]">
                {renderIframeImage ? (
                  <img key={imageRender} src={IframeImage[imageRender]} className="object-cover" />
                ) : (
                  <img key={DefaultIframeImage} src={DefaultIframeImage} className="object-cover" />
                )}
                {/* <div className="w-full h-full flex items-center justify-center">
                  <span className="text-[#66666699] font-normal">No data yet! </span>
                </div> */}
              </div>
            </div>

            <div className="flex items-centre justify-end gap-2 border-r border-b py-2 pr-4  border-[#BECBD3] w-full">
              <div className=" flex items-center gap-2">
                <Button variant="secondary" size="small">
                  Save as Draft
                </Button>
                <Button variant="primary" size="small">
                  Deploy
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add section pop */}
      {addTemplate && (
        <Dialog open={addTemplate} onClose={CloseSectionPop}>
          <div className="w-[400px] flex flex-col">
            <div className="flex items-center justify-between px-[15px] py-[10px] rounded-t-[10px] border-b border-[#BECBD3] ">
              <p className="text-[#434852] font-[Poppins] text-base font-medium capitalize">Add New template</p>
              <button onClick={CloseSectionPop}>
                <CrossIcon />
              </button>
            </div>
            <div className="w-full min-h-0 grow p-2 flex flex-col items-center justify-center gap-y-2">
              <div className="flex flex-col gap-1 w-full">
                <div className="text-[#434852] font-poppins text-[12px] font-normal leading-normal">Name</div>
                <div className="w-full rounded-lg border flex items-center">
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="border-none w-full rounded-lg pl-2 outline-none focus:ring-0"
                    name="TemplateName"
                    value={addTemplateValues?.TemplateName}
                    onChange={(e) =>
                      setAddtemplateValues((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    style={{ borderLeftColor: selectedColor, borderLeft: "4px solid" }}
                  />

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setHandleColorBox(true);
                    }}
                  >
                    <i
                      className={`bi bi-palette-fill cursor-pointer h-[26px] mb-1`}
                      style={{ color: selectedColor }}
                    ></i>
                  </button>

                  {handleColorBox && (
                    <FloatingElement mode="vertical" xMargin={350}>
                      <div
                        className="fixed color-palette-panel grid grid-cols-4 rounded-md mt-[6px] -translate-x-12"
                        ref={colorcloseoutsideclick}
                      >
                        {colors.map((color, index) => (
                          <div
                            key={index}
                            className="color-box flex justify-center items-center w-full"
                            style={{
                              backgroundColor: color,
                              borderRadius: "3px",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              // border: choice.color_code === color ? "2px solid black" : "none", // Highlight selected color
                            }}
                            onClick={() => {
                              handleColorClick(color, index);
                              setHandleColorBox((prev) => !prev);
                            }}
                          ></div>
                        ))}
                      </div>
                    </FloatingElement>
                  )}
                  <div className="h-6 w-[1px] bg-[#CCCED1] mx-2"></div>
                  <div className="pr-2">
                    <True />
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-1 w-full">
                <div className="flex  items-start justify-centre gap-x-2 gap-y-1">
                  <div className="flexflex-col items-centre justify-centre gap-x-1 w-full">
                    <label className="text-[#434852] font-poppins text-md font-normal leading-normal gap-1">
                      Description
                    </label>
                    <textarea
                      id="descriptions"
                      name="Please enter description"
                      rows="4"
                      className="bg-white border border-DFE2E5 text-gray-900 text-sm block w-full rounded-md"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div className="pb-[15px] pr-[15px] flex justify-end gap-[10px]">
              <Button variant="secondary" size="small" onClick={CloseSectionPop}>
                Cancel
              </Button>
              <Button variant="primary" size="small" onClick={() => handleAddAndUpdateTemplate()}>
                Save
              </Button>
            </div>
          </div>
        </Dialog>
      )}

      {/* add pop */}
      {isConfirmDelete && (
        <ConfirmationDialog
          open={isConfirmDelete}
          onConfirm={() => handleDeleteTemplate()} //for api
          onClose={() => setIsConfirmDelete(false)}
          title="Delete Confirmation?"
          message={`Are you sure want to delete Template.`}
          confirmVariant="delete"
          confirmText="Delete"
          iconVariant="Delete"
          // cancelVariant="action"
          cancelText="Cancel"
          // variant="delete"
        />
      )}

      {/* view drawer for All Templates*/}
      {
        <CustomDrawer
          // open={viewAllTemplate}
          onClose={() => {
            setViewAllTemplate((prev) => !prev);
          }}
        >
          <div className="w-full flex flex-col h-full">
            {/* Header */}
            <div className="w-full flex items-center justify-between py-4 px-4 bg-[#1D4469] gap-2">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-white font-semibold text-base leading-[18px]">All Templates</span>
                <span className="text-white font-semibold text-base leading-[18px]">{getAllTemplate?.length}</span>
              </div>
              <div className="cursor-pointer text-white text-xl" onClick={() => setViewAllTemplate((prev) => !prev)}>
                *
              </div>
            </div>

            {/* Template List */}
            <div className="min-h-0 grow w-full flex flex-col px-4 py-3 overflow-y-auto thin-scrollbar gap-y-3">
              {getAllTemplate?.map((data, index) => (
                <div
                  key={index}
                  className="w-full flex items-start sm:items-center justify-start sm:justify-between gap-3 flex-wrap sm:flex-nowrap p-4 border border-[#86868680] rounded-lg cursor-pointer hover:bg-gray-50  transition"
                  onClick={(e) => {
                    handleTempleteList(data, e);
                  }}
                >
                  {/* Left indicator */}
                  <div className="flex items-center gap-4">
                    <div className="rounded-full w-4 h-4" style={{ backgroundColor: "#d4a373" }}></div>
                    <div className="h-12 w-[1px] bg-[#66666699] hidden sm:block"></div>
                  </div>

                  {/* Template Info */}
                  <div className="flex flex-col gap-y-1 sm:gap-y-2 text-left flex-1 min-w-0">
                    <div className="flex items-center gap-x-2 flex-wrap">
                      <Task2 />
                      <span className="text-[#666] text-sm font-medium truncate">{data?.template_name}</span>
                    </div>

                    <div className="flex items-center justify-start gap-x-4 text-xs text-[#66666699] w-full whitespace-nowrap overflow-hidden">
                      <span className="truncate">
                        <span className="font-semibold">Created by:</span>&nbsp;
                        <span className="font-normal">{data?.created_by}</span>
                      </span>

                      <div className="h-4 w-px bg-[#66666699]" />

                      <span className="truncate">
                        <span className="font-semibold">Created at:</span>&nbsp;
                        <span className="font-normal">{getDDMonthYYYYHM(data?.created_at)}</span>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </CustomDrawer>
      }
    </>
  );
};
export default AddTemplate;
